import { supabase } from '../../lib/supabase';
import { StripeServiceError, STRIPE_ERROR_MESSAGES } from '../../services/stripe/errors/types';

export {  validatePassword,  } from '../validation';

export async function validateAuthSession() {
  const { data: { session }, error: sessionError } = await supabase.auth.getSession();
  
  if (sessionError) {
    throw new StripeServiceError(STRIPE_ERROR_MESSAGES.AUTH_ERROR);
  }
  
  if (!session) {
    throw new StripeServiceError(STRIPE_ERROR_MESSAGES.AUTH_REQUIRED);
  }

  return session;
}